import { orderByFormLoader } from './order-by-radio';
import { variationFormLoader } from './product-variant-radio';
import { sidebarLoader } from './sidebar';

if (window.jQuery) {
    const $ = window.jQuery;

    $(window).on('load', () => {
        sidebarLoader($);
        variationFormLoader($);
        orderByFormLoader($);
    })
}